export const RECORDS_SERVICE_UNAVAILABLE_MESSAGE =
    "Сервис записи временно недоступен. Попробуйте ещё раз чуть позже.";

const TEMPORARY_GATEWAY_ERRORS = new Set([
    "term_gateway_unavailable",
    "term_gateway_invalid_response",
]);

export function getRecordGatewayErrorMessage(code: unknown): string | null {
    if (typeof code !== "string" || !TEMPORARY_GATEWAY_ERRORS.has(code.trim())) {
        return null;
    }

    return RECORDS_SERVICE_UNAVAILABLE_MESSAGE;
}
